









import {
    Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import _ from 'lodash'
import { TrelloCard } from '@/TrelloClient'
import { uiConfig } from '@/config'

@Component({
    components: {
    },
})
export default class extends Vue {

}
